import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const createCellRenderer = (conditionals) => {
    return (params) => {
        return (_jsx("div", { className: "flex items-center justify-center h-full w-full", children: conditionals
                .filter((item) => item.check(params.value))
                .map((item, index) => (_jsx(React.Fragment, { children: item.component }, `${item.field.toString()}-${index}`))) }));
    };
};
